import React from 'react';
import { Code, ArrowRight, Check, Terminal } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const APIPage = () => {
  const { login } = useAuth();
  const features = ['API RESTful completa', 'Webhooks em tempo real', 'Documentação detalhada', 'SDKs disponíveis'];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-gray-100 text-gray-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Code className="h-4 w-4" />API
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                <span className="text-[#3b82f6]">API</span> para Desenvolvedores
              </h1>
              <p className="text-xl text-gray-600 mb-8">Construa integrações personalizadas com nossa API RESTful completa.</p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">Ver documentação</Button>
            </div>
            <div className="bg-gray-900 rounded-3xl p-6 font-mono text-sm">
              <div className="flex items-center gap-2 mb-4">
                <Terminal className="h-5 w-5 text-green-400" />
                <span className="text-gray-400">Exemplo de requisição</span>
              </div>
              <div className="text-green-400 mb-2">POST /api/v1/messages</div>
              <div className="text-gray-300">
                <span className="text-purple-400">{'{'}</span><br/>
                <span className="ml-4">"to": <span className="text-yellow-400">"5511999..."</span>,</span><br/>
                <span className="ml-4">"text": <span className="text-yellow-400">"Olá!"</span></span><br/>
                <span className="text-purple-400">{'}'}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos da API</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((f) => (<div key={f} className="bg-white rounded-xl p-6 shadow-sm"><Check className="h-6 w-6 text-green-500 mb-3" /><p className="font-medium text-gray-900">{f}</p></div>))}
            </div>
          </div>
        </div>
        <div className="py-16"><div className="max-w-4xl mx-auto px-4"><Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white"><CardContent className="py-12 text-center"><h2 className="text-2xl font-bold mb-4">Comece a integrar</h2><Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">Ver documentação <ArrowRight className="ml-2 h-4 w-4" /></Button></CardContent></Card></div></div>
      </main>
      <Footer />
    </div>
  );
};
export default APIPage;
